import React from "react";
import { useTranslation } from "react-i18next";
import LegalPageLayout, {
  LegalList,
  LegalSection,
  LegalText,
} from "./LegalPageLayout";

const Privacy: React.FC = () => {
  const { t } = useTranslation();
  const h = (n: number) => t(`legal.privacy.h${n}`);
  return (
    <LegalPageLayout title={t("legal.privacy.title")} lastUpdated="2026-08-31">
      <p>{t("legal.privacy.intro")}</p>

      <LegalSection heading={h(1)}>
        <LegalList
          items={["a", "b", "c", "d", "e"].map((x) => t(`legal.privacy.l1${x}`))}
        />
      </LegalSection>

      <LegalSection heading={h(2)}>
        <LegalList
          items={["a", "b", "c", "d", "e", "f"].map((x) =>
            t(`legal.privacy.l2${x}`),
          )}
        />
      </LegalSection>

      <LegalSection heading={h(3)}>
        <p>{t("legal.privacy.p3")}</p>
      </LegalSection>

      <LegalSection heading={h(4)}>
        <p>{t("legal.privacy.p4")}</p>
      </LegalSection>

      <LegalSection heading={h(5)}>
        <p>{t("legal.privacy.p5")}</p>
      </LegalSection>

      <LegalSection heading={h(6)}>
        <p>
          <LegalText k="legal.privacy.p6" />
        </p>
      </LegalSection>

      <LegalSection heading={h(7)}>
        <p>{t("legal.privacy.p7")}</p>
      </LegalSection>

      <LegalSection heading={h(8)}>
        <p>
          <LegalText k="legal.privacy.p8" />
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default Privacy;
